/* eslint-disable react/no-multi-comp */
import React, { Component } from 'react';
import { withRouter } from 'react-router';
import cn from 'classnames';
// eslint-disable-next-line import/extensions
import { connect } from 'redux-zero/react';
import { injectIntl } from 'react-intl';

import { Helmet } from 'react-helmet';
import Tilt from 'react-tilt';
import { setDefaultProps } from 'react-on-visible';

import { actions } from '../../shared/store.js';
import PortfolioService from './portfolio.service.js';

import { Title } from '../../components/title/title.component.js';

import noDataCompanies from '../../assets/images/portfolio/company.svg';

import './portfolio.page.scss';

const Company = ({ company }) => (
	<Tilt
		className="company Tilt"
		options={{ max: 25, reset: true }}
		style={{
			background: company.color && company.color ? company.color : '#E9E9E9 ',
		}}
	>
		{/*  Link removed temp */}
		<div to="/portfolio">
			<div className="logo">
				<div className="logo-wrapper">
					{!company.whiteLogo.path && <span>{company.name}</span>}
					{company.whiteLogo.path && (
						<img
							className="Tilt-inner white"
							src={`${process.env.REACT_APP_API_ENDPOINT
								+ company.whiteLogo.path}`}
							alt={company.name}
						/>
					)}
					{company.colorLogo.path && (
						<img
							className="Tilt-inner color"
							src={`${process.env.REACT_APP_API_ENDPOINT
								+ company.colorLogo.path}`}
							alt={company.name}
						/>
					)}
				</div>
			</div>
		</div>
	</Tilt>
);

class HeaderSection extends Component {
	constructor(props) {
		super(props);

		this.overlayButtonTopRef = React.createRef();
	}

	componentDidMount() {
		const { showButton, hideButton } = this.props;

		this.overlayButtonLeftObserver = new IntersectionObserver((entries) => {
			const topButton = entries[0];

			if (!topButton.isIntersecting) {
				showButton();
			} else {
				hideButton();
			}
		});

		this.overlayButtonLeftObserver.observe(this.overlayButtonTopRef.current);
	}

	componentWillUnmount() {
		this.overlayButtonLeftObserver.unobserve(this.overlayButtonTopRef.current);
	}

	render() {
		const { title } = this.props;

		setDefaultProps({
			visibleClassName: 'visible',
			percent: 20,
		});

		return (
			<section className="header" ref={this.overlayButtonTopRef}>
				<div className="container container-fluid">
					<Title label={title} theme="dark" />
				</div>
			</section>
		);
	}
}

class PortfolioPage extends Component {
	static prefetchData = async language => Promise.all([
		PortfolioService.getPartnersName(language),
		PortfolioService.getPortfolioPageData(language),
	]);

	state = {
		partners: this.props.portfolioPartners
			? this.props.portfolioPartners.data
			: [],
		hideOverlayButtonTop: false,
	};

	componentDidMount() {
		const { portfolioData, portfolioPartners, setLoading } = this.props;

		if (!portfolioData || !portfolioPartners) {
			this.fetchData();
		} else {
			setLoading(false);
		}
	}

	componentDidUpdate(prevProps) {
		const { language, portfolioPartners } = this.props;
		if (prevProps.language.value !== language.value) {
			this.fetchData();
		}

		// TODO: Review this setState
		if (prevProps.portfolioPartners !== portfolioPartners) {
			this.setState({
				partners: portfolioPartners.data,
			});
		}
	}

	showButton = () => {
		this.setState({ hideOverlayButtonTop: false });
	};

	hideButton = () => {
		this.setState({ hideOverlayButtonTop: true });
	};

	goTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

	fetchData() {
		const {
			setLoading,
			setPortfolioPartners,
			setPortfolioPageData,
			language,
		} = this.props;

		setLoading(true);

		PortfolioPage.prefetchData(language.value)
			.then(([partnersData, pageData]) => {
				setPortfolioPartners(partnersData);
				setPortfolioPageData(pageData);
				setLoading(false);
			})
			.catch(() => {
				setLoading(false);
				const { history } = this.props;
				setLoading(false);
				history.push('/404');
				this.setState({
					hasError: true,
				});
			});
	}

	render() {
		const {
			intl,
			portfolioPartners,
			portfolioPageData,
		} = this.props;
		const {
			partners,
			hideOverlayButtonTop,
			hasError,
		} = this.state;

		if (hasError || !portfolioPartners || !portfolioPageData) {
			return null;
		}

		const { title } = portfolioPageData;

		return (
			<div id="portfolio-page">
				<div
					className={cn('button-wrapper', {
						hide: hideOverlayButtonTop,
					})}
				>
					<button type="button" className="oval-button" onClick={this.goTop}>
						<span className="arrow" />
					</button>
				</div>

				<Helmet>
					<title>
						{intl.formatMessage({
							id: 'navigation.portfolio',
						})}
					</title>
					<meta
						name="description"
						content={title}
					/>
					<link
						rel="canonical"
						href={`${
							process.env.REACT_APP_URL
						}/portfolio`}
					/>

					<meta
						property="og:url"
						content={`${
							process.env.REACT_APP_URL
						}/portfolio`}
					/>

				</Helmet>

				<HeaderSection
					showButton={this.showButton}
					hideButton={this.hideButton}
					title={title}
				/>
				<div className="companies">
					<div className="container container-fluid">
						<div className="row">
							{partners.map((partner, index) => (
								<div
									className="col-xs-6 col-sm-4 col-md-3"
									key={`${partner.name}-${index}`}
								>
									<Company company={partner} />
								</div>
							))}
							{partners.length === 0 && (
								<div className="col-xs-12 center-xs">
									<div className="no-data">
										<img src={noDataCompanies} alt="No companies" />
										<h6>
											{intl.formatMessage({
												id: 'portfolio.no_data.no_companies',
											})}
										</h6>
										<span>
											{intl.formatMessage({
												id: 'portfolio.no_data.no_companies.select_other',
											})}
										</span>
									</div>
								</div>
							)}
						</div>
					</div>
				</div>
			</div>
		);
	}
}

const mapToProps = ({
	language,
	portfolioPageData,
	portfolioPartners,
	isLoading,
}) => ({
	language,
	portfolioPartners,
	portfolioPageData,
	isLoading,
});

export default withRouter(
	injectIntl(
		connect(
			mapToProps,
			actions,
		)(PortfolioPage),
	),
);

export { PortfolioPage };
